import { cn } from '@/lib/cn'
import type { ReactNode } from 'react'

interface ErrorStateProps {
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function ErrorState({ title, description, action, className }: ErrorStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center text-[var(--content-secondary)]',
        className,
      )}
      role="alert"
    >
      <div
        aria-hidden="true"
        className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-red-50 text-red-600"
      >
        <span className="text-lg font-bold">!</span>
      </div>
      <h3 className="text-lg font-heading font-semibold text-[var(--content)]">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-[var(--content-secondary)] max-w-md">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
